import { render } from "./BlogSideBarDentalTourism.vue?vue&type=template&id=5a0a148a"
import script from "./BlogSideBarDentalTourism.vue?vue&type=script&lang=js"
export * from "./BlogSideBarDentalTourism.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__